// extracted by mini-css-extract-plugin
export default {"documentItem":"DocumentItem_documentItem__-lI+L","card":"DocumentItem_card__Hyx1b"};